/**
 * @generated SignedSource<<5a38a9adc5833c55571a50cddbcd9831>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type landingBannerInfographicArticle$data = {
  readonly coverHero: {
    readonly url: string;
  } | null | undefined;
  readonly headline: string | null | undefined;
  readonly images: ReadonlyArray<{
    readonly title: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleShareWidgetArticle" | "articleSponsorContent">;
  readonly " $fragmentType": "landingBannerInfographicArticle";
};
export type landingBannerInfographicArticle$key = {
  readonly " $data"?: landingBannerInfographicArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"landingBannerInfographicArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "landingBannerInfographicArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleShareWidgetArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "coverHero",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "HERO"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": "image(filter:{\"type\":\"HERO\"})"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "b857b5029e524df73648623dd0756e2d";

export default node;
